/**
 * TicketSalesCampaignStatusPill — Live / Scheduled / Disabled / Ended, on the
 * shared `nb-pill` shape. Disabled is outlined with a faded dot because it is
 * switched off rather than over.
 */
import { TicketSalesCampaignStatus } from '@bonsai/shared';

const STATUS_META: Record<
  TicketSalesCampaignStatus,
  { label: string; color: string; background: string; borderColor: string }
> = {
  [TicketSalesCampaignStatus.LIVE]: {
    label: 'Live',
    color: 'var(--nb-primary-2)',
    background: 'var(--nb-primary-soft)',
    borderColor: 'transparent',
  },
  [TicketSalesCampaignStatus.SCHEDULED]: {
    label: 'Scheduled',
    color: 'var(--nb-info)',
    background: 'var(--nb-info-soft)',
    borderColor: 'transparent',
  },
  [TicketSalesCampaignStatus.DISABLED]: {
    label: 'Disabled',
    color: 'var(--nb-subtle)',
    background: 'var(--nb-bg)',
    borderColor: 'var(--nb-border)',
  },
  [TicketSalesCampaignStatus.ENDED]: {
    label: 'Ended',
    color: 'var(--nb-muted)',
    background: 'var(--nb-surface-2)',
    borderColor: 'transparent',
  },
};

export default function TicketSalesCampaignStatusPill({
  status,
}: {
  status: TicketSalesCampaignStatus;
}) {
  const { label, ...style } = STATUS_META[status];
  return (
    <span className="nb-pill" style={style}>
      <i
        className="nb-pill-dot"
        aria-hidden="true"
        style={{ opacity: status === TicketSalesCampaignStatus.DISABLED ? 0.5 : 1 }}
      />
      {label}
    </span>
  );
}
